import {addLocaleData} from 'react-intl';

// Bundle English
import reactIntlEn from 'react-intl/locale-data/en';

const importReactIntlLangs = {
  en: () => Promise.resolve(reactIntlEn),
  ja: () => import('react-intl/locale-data/ja'),
  de: () => import('react-intl/locale-data/de'),
  fr: () => import('react-intl/locale-data/fr'),
  zh: () => import('react-intl/locale-data/zh'),
  es: () => import('react-intl/locale-data/es'),
  nl: () => import('react-intl/locale-data/nl'),
  pt: () => import('react-intl/locale-data/pt'),
};

const importIntl = () => import(/* webpackChunkName: 'intl' */ 'intl');
const importIntlLangs = {
  en: () => import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/en'),
  'en-AU': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/en-AU'),
  'en-CA': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/en-CA'),
  'en-150': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/en-150'),
  'en-HK': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/en-HK'),
  'en-IE': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/en-IE'),
  'en-IL': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/en-IL'),
  'en-MO': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/en-MO'),
  'en-NL': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/en-NL'),
  'en-NZ': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/en-NZ'),
  'en-SG': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/en-SG'),
  'en-GB': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/en-GB'),
  'en-001': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/en-001'),
  ja: () => import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/ja'),
  de: () => import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/de'),
  'de-AT': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/de-AT'),
  'de-CH': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/de-CH'),
  fr: () => import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/fr'),
  'fr-BE': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/fr-BE'),
  'fr-CA': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/fr-CA'),
  'fr-CH': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/fr-CH'),
  zh: () => import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/zh'),
  'zh-Hans-HK': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/zh-Hans-HK'),
  'zh-Hans-MO': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/zh-Hans-MO'),
  'zh-Hans-SG': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/zh-Hans-SG'),
  es: () => import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/es'),
  'es-419': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/es-419'),
  'es-MX': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/es-MX'),
  'es-US': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/es-US'),
  nl: () => import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/nl'),
  'nl-BE': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/nl-BE'),
  pt: () => import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/pt'),
  'pt-PT': () =>
    import(/* webpackChunkName: 'intl' */ 'intl/locale-data/jsonp/pt-PT'),
};

const resolveLocale = locale => {
  switch (locale) {
    case 'en-US':
    case 'de-DE':
    case 'fr-FR':
    case 'es-ES':
    case 'nl-NL':
    case 'pt-PT':
    case 'ja-JP':
    case 'zh-CN':
      return locale.substring(0, 2);
    default:
      return locale;
  }
};

const loadReactIntl = locale =>
  // Always reduce locale when loading react-intl
  importReactIntlLangs[locale.substring(0, 2)]().then(mod =>
    addLocaleData(mod.default)
  );

const loadIntl = locale =>
  // Only reduce base locales using resolveLocale when
  // loading intl data
  global.Intl
    ? Promise.resolve()
    : importIntl().then(importIntlLangs[resolveLocale(locale)]);

export const init = () => {
  const locale = global.ENV.locale || 'en';
  return Promise.all([loadIntl(locale), loadReactIntl(locale)]);
};
